import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import PerformanceAnalysisComponent from '../components/dashboard/PerformanceAnalysis';

export default function PerformanceAnalysisPage() {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Breadcrumb header */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-2 text-sm">
            <Link
              to="/dashboard"
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              Dashboard
            </Link>
            <ChevronRight className="w-4 h-4 text-gray-400" />
            <Link
              to="/dashboard/valuations"
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              Valuations
            </Link>
            <ChevronRight className="w-4 h-4 text-gray-400" />
            <span className="text-gray-500">Property Analysis</span>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-6">
        <PerformanceAnalysisComponent valuationId={id} />
      </div>
    </div>
  );
}
